// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/javascript/style/main.scss
// module id = 139
// module chunks = 2